import {
    Box,
    FormControl,
    MenuItem,
    Select,
    Stack,
    Typography,
} from '@mui/material';
import type { SelectChangeEvent } from '@mui/material/Select';
import type { SxProps, Theme } from '@mui/material/styles';

export interface CapacityDropdownRowProps {
    title: string;
    subtitle: string;
    vehicleValue: string;
    vehicleOptions: Array<{ label: string; value: string }>;
    remaining: number;
    onVehicleChange?: (nextValue: string) => void;
    disabled?: boolean;
    sx?: SxProps<Theme>;
}

const CapacityDropdownRow = ({
    title,
    subtitle,
    vehicleValue,
    vehicleOptions,
    remaining,
    onVehicleChange,
    disabled,
    sx,
}: CapacityDropdownRowProps) => {
    const handleVehicleChange = (event: SelectChangeEvent<string>) => {
        onVehicleChange?.(event.target.value);
    };

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={{ xs: 1, sm: 2 }}
            sx={{
                py: 1.25,
                minHeight: 68,
                width: 1,
                ...sx,
            }}
        >
            <Box sx={{ minWidth: 0, flexGrow: 1, pr: 1 }}>
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: 'text.primary',
                    }}
                    noWrap
                >
                    {title}
                </Typography>
                <Typography
                    sx={{
                        mt: 0.25,
                        fontSize: '12px',
                        color: 'text.secondary',
                    }}
                    noWrap
                >
                    {subtitle}
                </Typography>
            </Box>

            <FormControl
                size="small"
                sx={{
                    width: 120,
                    flexShrink: 0,
                }}
            >
                <Select
                    value={vehicleValue}
                    onChange={handleVehicleChange}
                    disabled={disabled}
                    displayEmpty
                >
                    {vehicleOptions.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <Typography
                sx={{
                    fontSize: '12px',
                    color: 'text.secondary',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    width: 80,
                    ml: 'auto',
                }}
            >
                Remaining: {remaining}
            </Typography>
        </Stack>
    );
};

export default CapacityDropdownRow;
